module.exports = __webpack_public_path__ + "img/step54_a_printer_basic_connect_power_lan_cable.22fc749a.png";